import { render, staticRenderFns } from "./carryDialog.vue?vue&type=template&id=56f04a3a&scoped=true"
import script from "./carryDialog.vue?vue&type=script&lang=js"
export * from "./carryDialog.vue?vue&type=script&lang=js"
import style0 from "./carryDialog.vue?vue&type=style&index=0&id=56f04a3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f04a3a",
  null
  
)

export default component.exports